import React from 'react'
import heropic from '../images/pic.png'


const Question = () => {
  return (
    <div className='h-auto '>
      <div className="md:flex justify-between items-center p-20 gap-2 max-sm:flex-row">
        <div className="md:w-3/5 max-sm:w-full ">
          <h1 className="text-5xl font-semibold">Innovative approaches that stand out</h1>
          <p className='mt-4'>Our agency boosts your brand by placing it on free, custom-designed water bottles. These bottles,
            distributed directly to consumers, keep your brand front and center in their daily lives.</p>
          <p className='mt-3'>It's a simple yet powerful way to increase visibility, create positive brand associations,
            and build loyalty—all while offering something useful that people appreciate</p>
        </div>
        <div className="md:w-3/5 max-sm:w-full">
          <img src={heropic} alt="" />
        </div>
      </div>
    </div>
  )
}

export default Question